import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    renderData: [],
    status: 'idle',
};

export const getGallery = createAsyncThunk('/gallery/get', async () => {

    let res = axios.get('gallery',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      return data.data.data.Slider


    
})

export const createGallery = createAsyncThunk('/gallery/create', async (item) => {

    let res = axios.post('gallery', item,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data, "suppoort post");
      if(data.data.success){
        alert("Galereyaga qo'shildi")
      }


    
})

export const deleteGallery = createAsyncThunk('/gallery/delete', async (item) => {

    let res = axios.delete(`gallery/${item._id}`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data, "suppoort post");
      if(data.data.success){
        alert("Surat o'chirildi")
      }


    
})
// export const deleteCategory = createAsyncThunk('/categories/delete', async (item) => {

//     let res = axios.delete(`categories/${item.parent._id}`,{
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('token')}`
//         }
//       }).catch((err)=>{
//         console.log(err)
//         // setError(err.response.data.message)
//       })
      
      
//       const data = await res
//       console.log(data);
//       if(data.data.success){
//         alert("Kategoriya o'chirildi")
//       }


    
// })
const gallery = createSlice({
    name: 'gallery',
    initialState,
    reducers: {

    },
    extraReducers(builder) {
      builder
      .addCase(getGallery.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getGallery.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getGallery.fulfilled,(state, action) => {
        // state.status = "idle";
        console.log(action.payload, 'payload');
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createGallery.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      .addCase(deleteGallery.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      }
  });


export const reducer = gallery.reducer;